import seedrandom from 'seedrandom';
import {getTodaysDate} from 'common/components/LibraryController/FilteringController/FilterConfigs/DateRangeFunctions';

export function getTodaysRandom(seed: string, upTo: number) {
    const date = getTodaysDate();
    const random = seedrandom(date + seed);
    const randomFloat = random();
    return Math.round(randomFloat * upTo);
}
